import React, { Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react';
import { RgbaColor, rgbStringToHsva, hsvaToRgba } from '@uiw/color-convert';
import { HsvaColor } from '@uiw/color-convert';
import { ColorPicker, ControlWrapper } from '../../..';
import { rgbaToRgbString } from '../../../../utils/helpers';
import { LightSlider } from '../../../light-slider';

type RgbPickerProps = {
  rgbValue: string;
  handleColorPicked: (rgba: RgbaColor) => void;
  brightness?: number;
  handleChange?: (val: number) => void;
  handleBrightness?: (val: number) => void;
  isOn?: boolean;
  brightnessLabel?: string;
  children?: ReactNode;
  setPreventSwipeViews?: Dispatch<SetStateAction<boolean>>;
};

const RgbPicker: React.FC<RgbPickerProps> = ({
  rgbValue,
  handleColorPicked,
  brightness,
  handleChange,
  handleBrightness,
  isOn,
  brightnessLabel,
  children,
  setPreventSwipeViews,
}) => {
  const [hsva, setHsva] = useState<HsvaColor>({ h: 214, s: 43, v: 100, a: 1 });

  useEffect(() => {
    if (rgbValue)
      setHsva((prev) => ({
        ...prev,
        ...rgbStringToHsva(`rgb(${rgbValue})`),
        v: 100,
        a: 1,
      }));
  }, [rgbValue]);

  const handlePointerUp = () => handleColorPicked(hsvaToRgba(hsva));

  const handleChangeBrightness = (val: number) => {
    handleChange?.(val);
  };

  const sliderColor = rgbaToRgbString(hsvaToRgba(hsva));

  return (
    <>
      <ControlWrapper className="control-wrapper--medium">
        <ColorPicker
          handlePointerUp={handlePointerUp}
          isOn={isOn}
          setPreventSwipeViews={setPreventSwipeViews}
          hsva={hsva}
          setHsva={setHsva}
        />
      </ControlWrapper>
      {children}
      {handleBrightness && handleChange && brightness !== undefined ? (
        <div className="details-page__controls-slider p-l-24 p-r-24">
          <LightSlider
            value={brightness}
            onChange={handleChangeBrightness}
            onPointerUp={handleBrightness}
            gradientColor={sliderColor}
            {...(brightnessLabel ? { label: brightnessLabel } : {})}
          />
        </div>
      ) : null}
    </>
  );
};
export default RgbPicker;
